import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';

import type { PatientVaccinationData } from 'chaika-frontend-types/frontend-cms';

const STAGE_ORDER = ['V', 'V1', 'V2', 'V3', 'V4', 'Rv', 'R1', 'R2', 'R3'];
const NO_DISEASE_GROUP_KEY = 'undefined';

export interface VaccinationsByDisease<T> {
    groupName: string;
    vaccinations: T[];
}

export function groupVaccinationsByDisease<T extends PatientVaccinationData>(
    vaccinations: T[],
    noDiseaseGroupName: string,
): VaccinationsByDisease<T>[] {
    const groups = groupBy<T>(sortBy(vaccinations, 'disease'), 'disease');

    return Object.entries(groups).map(([groupName, groupVaccinations]) => ({
        vaccinations:
            groupName === NO_DISEASE_GROUP_KEY
                ? orderBy(groupVaccinations, 'vaccinationDate')
                : sortBy(groupVaccinations, ({ stage }) => getStageOrder(stage)),
        groupName: groupName === NO_DISEASE_GROUP_KEY ? noDiseaseGroupName : groupName,
    }));
}

function getStageOrder(stage: string): number {
    return STAGE_ORDER.includes(stage) ? STAGE_ORDER.indexOf(stage) : STAGE_ORDER.length;
}
